// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-header-dropdown-index-container"};